/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TTL } from '../../environments/plugins';

export class IpAddressInterface {
	ip!: string;
}

@Injectable({ providedIn: 'root' })
export class DataProvider implements OnDestroy {
	headers = new HttpHeaders().set('Content-Type', 'application/json');
	private destroy$ = new Subject();
	private storage: Storage | null;

	private http = inject(HttpClient);
	private platformId: object = inject(PLATFORM_ID);

	constructor() {
		this.headers = this.headers.append('x-refresh', '');
		this.headers = this.headers.append('Cache-Control', `max-age=${TTL}, stale-while-revalidate=${TTL}`);
		this.storage = isPlatformBrowser(this.platformId) ? sessionStorage : null;
	}

	public getLocalData(localDataUrl: string): Observable<any> {
		return this.http.get(localDataUrl).pipe(map((response: Response | any) => response as any));
	}

	public getData(dataUrl: string): Observable<any> {
		return this.http.get(environment.cmsUrl + dataUrl, { headers: this.headers }).pipe(map((response: Response | any) => response as any));
	}

	// Record<any, Object>
	public postData(dataUrl: string, payload: any): Observable<any> {
		if (this.storage) {
			const ipAddress = this.storage.getItem('IPAddress');

			// If IP Address exists, use it, instead of calling it
			if (ipAddress) {
				payload.IpAddress = ipAddress;

				return this.http.post(environment.oldCmsUrl + dataUrl, payload);
			}
			// Otherwise....
			else {
				return this.getIPAddress().pipe(
					takeUntil(this.destroy$),
					map((ip: string) => {
						this.storage!.setItem('IPAddress', ip);
						return ip;
					}),
					switchMap((ip: string) => {
						payload.IpAddress = ip ? ip : 'N/A';
						return this.http.post(environment.oldCmsUrl + dataUrl, payload);
					}),
					map((response: Response | any) => response)
				);
			}
		} else {
			return of(null);
		}
	}

	getIPAddress(): Observable<string> {
		return this.http.get('https://api.ipify.org?format=json').pipe(map((response: any) => response.ip));
	}

	ngOnDestroy(): void {
		this.destroy$.next('');
		this.destroy$.complete();
		this.destroy$.unsubscribe();
	}
}
